export const SQUARE_HORIZONTAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.SquareHorizontalItemElement';
export const CIRCLE_HORIZONTAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.CircleHorizontalItemElement';
